import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Link, useLocation } from 'react-router-dom';
import { Briefcase, Code, GraduationCap, Award, Languages, Settings, MessageSquare, LogOut, Menu, X, Home, Eye } from 'lucide-react';

const navItems = [
  { path: '/admin', label: 'Dashboard', icon: Home, exact: true },
  { path: '/admin/experiences', label: 'Experiências', icon: Briefcase },
  { path: '/admin/skills', label: 'Skills', icon: Code },
  { path: '/admin/education', label: 'Formação', icon: GraduationCap },
  { path: '/admin/certifications', label: 'Certificações', icon: Award },
  { path: '/admin/languages', label: 'Idiomas', icon: Languages },
  { path: '/admin/settings', label: 'Configurações', icon: Settings },
  { path: '/admin/messages', label: 'Mensagens', icon: MessageSquare },
  { path: '/admin/preview', label: 'Preview', icon: Eye },
];

const AdminLayout = ({ children }) => {
  const { signOut } = useAuth();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const isActive = (item) => item.exact ? location.pathname === item.path : location.pathname.startsWith(item.path);

  return (
    <div className="min-h-screen bg-black flex">
      {/* Mobile overlay */}
      {sidebarOpen && <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setSidebarOpen(false)} />}

      {/* Sidebar */}
      <aside className={`fixed lg:static inset-y-0 left-0 z-50 w-64 bg-gray-950 border-r border-gray-800 transform transition-transform duration-300 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0`}>
        <div className="flex items-center justify-between p-6 border-b border-gray-800">
          <Link to="/" className="text-2xl font-black text-lime-400">JPB Admin</Link>
          <button className="lg:hidden text-gray-400" onClick={() => setSidebarOpen(false)}><X size={20} /></button>
        </div>
        <nav className="p-4 space-y-1">
          {navItems.map(item => (
            <Link key={item.path} to={item.path} onClick={() => setSidebarOpen(false)}
              className={`flex items-center space-x-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${isActive(item) ? 'bg-lime-400/10 text-lime-400 border border-lime-400/30' : 'text-gray-400 hover:text-white hover:bg-gray-800'}`}>
              <item.icon size={18} /><span>{item.label}</span>
            </Link>
          ))}
        </nav>
        <div className="absolute bottom-0 w-full p-4 border-t border-gray-800">
          <button onClick={signOut} className="flex items-center space-x-3 px-4 py-3 w-full rounded-lg text-sm font-medium text-red-400 hover:bg-red-900/20 transition-colors">
            <LogOut size={18} /><span>Sair</span>
          </button>
        </div>
      </aside>

      {/* Main content */}
      <div className="flex-1 flex flex-col min-h-screen">
        <header className="bg-gray-950 border-b border-gray-800 px-6 py-4 flex items-center lg:hidden">
          <button onClick={() => setSidebarOpen(true)} className="text-gray-400"><Menu size={24} /></button>
          <span className="ml-4 text-lg font-bold text-lime-400">JPB Admin</span>
        </header>
        <main className="flex-1 p-6 lg:p-8 overflow-auto">{children}</main>
      </div>
    </div>
  );
};

export default AdminLayout;
